export default __webpack_public_path__ + "2f56917532ea3ada5a047bbd31b3666c.png";